import * as React from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import UserCreationContext from "./UserCreationContext";

export default function CodeGenerator() {
  const { email, setEmail } = React.useContext(UserCreationContext);

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value);
  };

  return (
    <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: 2 }}>
      <Typography variant="h6">Einladung vorbereiten</Typography>
      <TextField
        id="invite-email"
        label="E-Mail Adresse"
        type="email"
        size="small"
        value={email}
        onChange={handleEmailChange}
        error={email.length > 0 && !email.includes("@")}
        helperText="Die Einladung wird an diese Adresse gesendet."
      />
    </Box>
  );
}
